module.exports = __webpack_public_path__ + "img/explortaion_example_3.eb8fbd33.png";